import api from "./axios";

export const getFeatureCatalog = () =>
  api.get("/feature-catalog").then((r) => r.data);

export const upsertFeatureCategory = ({ category, features }) =>
  api.post("/feature-catalog", { category, features }).then((r) => r.data);

// DELETE a category by name
export const deleteFeatureCategory = (category) =>
  api
    .delete(`/feature-catalog/${encodeURIComponent(category)}`)
    .then((r) => r.data);

export const deleteFeature = (category, feature) =>
  api.delete(
    `/feature-catalog/${encodeURIComponent(
      category
    )}/feature/${encodeURIComponent(feature)}`
  );

export const renameCategory = (oldCategory, newCategory) =>
  api
    .put(`/feature-catalog/${encodeURIComponent(oldCategory)}`, { newCategory })
    .then((r) => r.data);

export const renameFeature = (category, oldFeature, newFeature) =>
  api
    .put(`/feature-catalog/${encodeURIComponent(category)}/feature`, {
      oldFeature,
      newFeature,
    })
    .then((r) => r.data);
